import React, { Component } from 'react';
import PropTypes from 'prop-types';
import cns from 'classnames';
import VerbButton, { VERB_BUTTON_TYPE } from '../../VerbButton';
import TextInput from '../inputs/TextInput';

class BasicUrlResource extends Component {
    static propTypes = {
        handleSubmit: PropTypes.func.isRequired,
        className: PropTypes.string,
        label: PropTypes.string,
        required: PropTypes.bool
    };

    constructor(props) {
        super(props);

        this.state = {
            newResourceTitle: '',
            newResourceUrl: '',
            openInNewTab: true
        };
    }

    _handleResourceTitleChange = (e) => {
        this.setState({ newResourceTitle: e.target.value });
    };

    _handleResourceUrlChange = (e) => {
        this.setState({ newResourceUrl: e.target.value });
    };

    render() {
        const { newResourceTitle, newResourceUrl } = this.state;
        const { handleSubmit, className, label, required = false } = this.props;
        let labelSection;

        if (label) {
            labelSection = (
                <label>
                    {label}
                    {required && <span className={'required-tag'}>*</span>}
                </label>
            );
        }

        return (
            <div>
                {labelSection}
                <div className={cns('row', className)}>
                    <div className={'col-4'}>
                        <TextInput
                            placeholder={'Resource URL'}
                            name={'newResourceTitle'}
                            value={newResourceUrl}
                            onChange={this._handleResourceUrlChange}
                        />
                    </div>

                    <div className={'col-4'}>
                        <TextInput
                            placeholder={'Resource Title'}
                            name={'newResourceTitle'}
                            value={newResourceTitle}
                            onChange={this._handleResourceTitleChange}
                        />
                    </div>
                    <div className={'col-2'}>
                        <label>Links will be opened in a new tab.</label>
                    </div>
                    <div className={'col-4'} />
                    <VerbButton
                        fontAwesomeIcon={'fa-plus'}
                        buttonType={VERB_BUTTON_TYPE.PRIMARY_DEFAULT}
                        onClick={() => handleSubmit(this.state)}
                    >
                        Add Resource
                    </VerbButton>
                </div>
            </div>
        );
    }
}

export default BasicUrlResource;
